import '../DataCollection.css';
import {useForm} from "react-hook-form";
import {useState} from "react";

/*
* TextInput
* The best way to use this is to pass in the state object that has an attribute of the value you want to manage, the name of the variable in that state that you want to manage,
* and a function to update that state.  The onChange function will be called with the event object, and the state will be updated with the new value.
*
* EXAMPLE - this manages the firstName attribute of the subscriber object in the state, and updates it with the setSubscriber function:
    <TextInput
        label={t('Given Name')}
        name={'firstName'}
        state={state.subscriber}
        onChange={handleChange(state.setSubscriber)}
        validationRules={{required: true}}
    />

 */
const SINInput = ({label, placeholder, value, name, state, validationRules, validationCallback = undefined, onChange, innerRef, ...rest}) => {
    const {register, handleSubmit, watch, formState: {errors}} = useForm({mode: 'onBlur'});
    const [errorClass, setErrorClass] = useState('');

    const _onBlur = (e) => {

        let text = e.target.value;

        if (validationCallback) {
            let newText = validationCallback(text);
            if (newText === '' && e.target.value !== '') {
                setErrorClass('error');
            } else {
                setErrorClass('');
            }
            text = newText;
        }

        const newEvent = {
            target: {
                name: e.target.name,
                value: text
            }
        }

        onChange(newEvent);

    }

    if (state && name !== undefined) {
        value = state[name];
    }

    if (name === undefined) {
        console.error(`name is undefined for text input label: ${label}, placeholder: ${placeholder}`);
        name = "UNDEFINED!"
        placeholder = "UNDEFINED!"

        onChange = (e) => {
            console.error(`name is undefined for text input cannot store value! label: ${label}, placeholder: ${placeholder}`)
        }
    }

    if (validationRules) {
        //TODO: This was added for custom validation but may not be needed anymore
        validationRules = (validationRules[state] || {})[name] || validationRules;
    }

    //let errorClass = errors[name] ? 'error' : '';

    return (
        <div className={'form-input-area__input '}>
            <label>
                {label && <span>{label} </span>}
                <input {...register(name, validationRules)}
                       type="text"
                       name={name}
                       placeholder={placeholder}
                       value={value}
                       onChange={onChange}
                       className={errorClass}
                       onBlur={_onBlur}
                       ref={innerRef}
                       {...rest}
                />
                {validationRules && validationRules.required && <span className={'required-input'}>*</span>}
            </label>
            {errorClass !== '' &&
                <div className={'error-message'}>The SIN number entered was invalid</div>
            }
        </div>
    )
}

export default SINInput;